
export enum GridHeaderMenuTypeChange {
  isEditing = 'isEditing',
  isHiding = 'isHiding',
  isPriceBanding = 'isPriceBanding',
  isSorting = 'isSorting'
}
